import { TEST_FLOW, TEST_SCRIPT } from "../actions/types";
const initialState = {
  scriptResult: undefined
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TEST_FLOW:
      return {
        ...state,
      };
    case TEST_SCRIPT:
      return {
        ...state,
        scriptResult: action.payload,
      };
    default:
      return state;
  }
}
